import {
  BatteryHVSOCUnitEnum,
  EngineTypeEnum,
  FluidTypeEnum,
  FuelTypeEnum,
  QuantityTypeEnum,
  RecordActivityTypeEnum,
  Select,
  TyreActionTypeEnum,
  VehicleWashTypeEnum,
  YesNoEnum,
  YesNoNAEnum,
} from '@/types';

export const jobSources = [
  { value: 'RoutineMaintenance', label: 'Routine (calendar) maintenance' },
  { value: 'CustomerRequest', label: 'Customer request' },
  { value: 'AdHoc', label: 'Ad-hoc' },
];
export const yesNoOptions: Select<YesNoEnum>[] = [
  { value: YesNoEnum.Yes, label: 'Yes' },
  { value: YesNoEnum.No, label: 'No' },
];
export const yesNoNAOptions: Select<YesNoNAEnum>[] = [
  { value: YesNoNAEnum.Yes, label: 'Yes' },
  { value: YesNoNAEnum.No, label: 'No' },
  { value: YesNoNAEnum.NA, label: 'N/A' },
];
export const inputModes: Select<BatteryHVSOCUnitEnum>[] = [
  { value: BatteryHVSOCUnitEnum.KWh, label: 'KWh' },
  { value: BatteryHVSOCUnitEnum.Percent, label: 'Percent' },
];
export const fluidTypes: Select<FluidTypeEnum>[] = [
  { value: FluidTypeEnum.PowerSteeringFluid, label: 'Power Steering Fluid' },
  { value: FluidTypeEnum.BrakeFluid, label: 'Brake Fluid' },
  { value: FluidTypeEnum.WasherFluid, label: 'Washer Fluid' },
  { value: FluidTypeEnum.EngineOil, label: 'Engine Oil' },
  { value: FluidTypeEnum.TransmissionFluid, label: 'Transmission Fluid' },
];
export const quantityTypes: Select<QuantityTypeEnum>[] = [
  { value: QuantityTypeEnum.ML, label: 'ML' },
  { value: QuantityTypeEnum.Litres, label: 'Litres' },
];
export const fuelTypes: Select<FuelTypeEnum>[] = [
  { value: FuelTypeEnum.Diesel, label: 'Diesel' },
  { value: FuelTypeEnum.Unleaded, label: 'Unleaded' },
  { value: FuelTypeEnum.AdBlue, label: 'AdBlue' },
];
export const recordActivityTypes: Select<RecordActivityTypeEnum>[] = [
  {
    value: RecordActivityTypeEnum.JumpStartVehicle,
    label: 'Jump Start Vehicle',
  },
  { value: RecordActivityTypeEnum.TowAVehicle, label: 'Tow A Vehicle' },
];
export const vehicleWashTypes: Select<VehicleWashTypeEnum>[] = [
  { value: VehicleWashTypeEnum.StorageWash, label: 'Storage Wash' },
  { value: VehicleWashTypeEnum.AutomaticWash, label: 'Automatic Wash' },
  { value: VehicleWashTypeEnum.AcidWash, label: 'Acid Wash' },
];
export const engineTypes: Select<EngineTypeEnum>[] = [
  { value: EngineTypeEnum.ICE, label: 'ICE' },
  { value: EngineTypeEnum.EV, label: 'EV' },
  { value: EngineTypeEnum.Hybrid, label: 'Hybrid' },
];
export const tyreActionTypes: Select<TyreActionTypeEnum>[] = [
  { value: TyreActionTypeEnum.NoAction, label: 'No Action' },
  { value: TyreActionTypeEnum.Inflate, label: 'Inflate' },
  { value: TyreActionTypeEnum.Deflate, label: 'Deflate' },
];
